import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import selectHelper from '../../../Helpers/selectHelper';

export default class AntiFraudToolSearchParams extends SearchParamsBase {
  static iconName = 'fa-solid fa-search';
  static saveType = 'AntiFraudToolSearchParams';

  initialize() {
    this.RecordId = '';
    this.DetectedDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.StatusChangeDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.SelectedStatuses = ['Open', 'Under Investigation'];
    this.SelectedCountries = [];
  }

  static fieldsInSearchBox = [
    { fieldName: 'RecordId', label: 'Record ID', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'BaseShopperName', label: 'Base Shopper Name', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'MatchedShopperName', label: 'Matched Shopper Name', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'MatchedShopperEmail', label: 'Matched Shopper Email', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedStatuses',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: AntiFraudToolSearchParams.getStatusSelectOptions(),
    },
    { fieldName: 'AssignedToId', label: 'Assigned To', className: 'col-4', type: InputTypesEnum.UserSelect },
    {
      fieldName: 'SelectedFieldowrkOfficeIds',
      // label: 'FW Office',
      label: 'Ev. Pym Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'SelectedFwOfficeIds',
      label: 'FW Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'DetectedDate', label: 'Detected Date', className: 'col-4', type: InputTypesEnum.DateWithIndefinite },
    {
      fieldName: 'StatusChangeDate',
      label: 'Status Change Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
    },
    {
      fieldName: 'SelectedCountries',
      label: 'Country',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
  ];

  static getStatusSelectOptions() {
    return selectHelper.generateSelectValues(['Open', 'Under Investigation', 'Closed']);
  }
}
